import { render, staticRenderFns } from "./FormDescription.vue?vue&type=template&id=167cd4ad"
import script from "./FormDescription.js?vue&type=script&lang=js&external"
export * from "./FormDescription.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports